import * as React from 'react';
import { SVGProps } from 'react';

const IconCalendarSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h6V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h3a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3V4Zm16 9H5v9h18v-9Z"
    />
  </svg>
);
export default IconCalendarSizeL;
